import { useRouter } from 'next/router';

import { INTERNAL_PATHS } from '@/utils/urls';

export enum CUSTOMER_FEEDBACK_JOURNEY_KEY_OPTIONS {
  CHI_FEEDBACK = 'CHI_FEEDBACK',
  CHI_FEEDBACK_V2 = 'CHI_FEEDBACK_V2',
}

export const useSuccessHandler = (
  journeyKey?: CUSTOMER_FEEDBACK_JOURNEY_KEY_OPTIONS
) => {
  const { push } = useRouter();

  return () => {
    switch (journeyKey) {
      case CUSTOMER_FEEDBACK_JOURNEY_KEY_OPTIONS.CHI_FEEDBACK:
        return; // No redirect for CHI feedback
      case CUSTOMER_FEEDBACK_JOURNEY_KEY_OPTIONS.CHI_FEEDBACK_V2:
          push({
            pathname: INTERNAL_PATHS.CHI_SUCCESS.path,
          });
          break;
      default:
        push({
          pathname: INTERNAL_PATHS.CUSTOMER_FEEDBACK_SUCCESS.path,
        });
    }
  };
};
